import { render, staticRenderFns } from "./ManageOptionRules.vue?vue&type=template&id=16a6f64a"
import script from "./ManageOptionRules.vue?vue&type=script&lang=js"
export * from "./ManageOptionRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports